import React from 'react';

interface CourseStatusHorizontalProps {
  image: string | null;
  level: string | null;
  title: string | null;
  progress: {
    percentage: number;
    label: string;
  } | null;
  onResume: () => void;
  buttonText?: string;
  isStartButton?: boolean;
}

export const CourseStatusHorizontal: React.FC<CourseStatusHorizontalProps> = ({
  image,
  level,
  title,
  progress,
  onResume,
  buttonText = "Resume Learning",
  isStartButton = false
}) => {
  return (
    <article className="shadow-[0_14px_42px_0_rgba(8,15,52,0.06)] bg-white flex w-full gap-2.5 flex-wrap p-3 rounded-[10px] max-md:max-w-full">
      <div className="w-[229px] flex-shrink-0 overflow-hidden">
        <img
          src={image || ''}
          alt={title || ''}
          className="object-cover rounded-[10px]"
        />
      </div>
      <div className="flex min-w-60 flex-col items-stretch justify-center flex-1 shrink basis-8">
        {level && (
          <div>
            <div className="bg-[#D44D5C]/10 inline-flex items-center gap-2.5 text-xs text-[#928881] font-medium whitespace-nowrap px-2.5 rounded-[5px]">
              <span className="self-stretch my-auto">{level}</span>
            </div>
          </div>
        )}
        {progress ? (
          <>
            <h3 className="text-[#2D2D2D] text-base font-semibold leading-none tracking-[-0.32px] mt-2.5 mb-2">
              {title}
            </h3>
            <div className="flex items-center gap-4 mt-2.5">
              <div className="w-[211px] h-1.5 bg-medium rounded-full overflow-hidden">
                <div
                  className="h-full bg-success rounded-full transition-all duration-300 ease-in-out"
                  style={{ width: `${Math.min(Math.max(progress.percentage, 0), 100)}%` }}
                />
              </div>
              <div className="text-[#928881] text-base font-normal self-stretch my-auto">
                {progress.label}
              </div>
            </div>
          </>
        ) : (
          <div>
            <div className="text-[#2D2D2D] text-xl font-semibold leading-tight tracking-[-0.4px] mt-2.5">
              {title}
            </div>
            <div>
              <div className="text-[#928881] text-base font-normal mt-2.5" style={{ height: 40 }}>
                Click start learning to begin your journey!
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="flex items-center justify-end">
        <button
          onClick={onResume}
          className={`shadow-[0px_1px_0px_rgba(0,0,0,0.05)] flex items-center gap-2 text-white font-medium justify-center rounded-lg transition-colors min-w-[160px] ${
            isStartButton 
              ? "bg-success hover:bg-success/90 min-h-12 text-lg px-6 py-2.5 flex-col leading-none gap-0 font-bold" 
              : "bg-[#D44D5C] hover:bg-[#D44D5C]/90 min-h-12 text-lg px-6 py-2.5 flex-col leading-none gap-0 font-bold"
          }`}
        >
          {isStartButton ? (
            <>
              <span className="text-xl">Click</span>
              <span>to Begin</span>
            </>
          ) : (
            (() => {
              const words = buttonText.split(' ');
              const firstWord = words[0];
              const rest = words.slice(1).join(' ');
              return (
                <>
                  <span className="text-xl">{firstWord}</span>
                  <span>{rest}</span>
                </>
              );
            })()
          )}
        </button>
      </div>
    </article>
  );
};
